import React from "react";
import "./Popup.css";

const SuccessPopup = ({ message, onClose }) => (
  <div className='popup-backdrop'>
    <div className='popup success'>
      <h4>✅ Success</h4>
      <p>{message}</p>
      <button onClick={onClose}>OK</button>
    </div>
  </div>
);

export default SuccessPopup;
